import {
  type Bucket,
  BUCKETS,
} from '../../../stores/JobApplicationStore/types';

const BUCKET_MAPPING: Record<string, BUCKETS> = {
  Inbox: BUCKETS.INBOX,
  Interview: BUCKETS.INTERVIEW,
  Offer: BUCKETS.OFFER,
  Accept: BUCKETS.ACCEPT,
  Shortlist: BUCKETS.SHORTLIST,
  Rejected: BUCKETS.NOT_SUITABLE,
  Prescreen: BUCKETS.PRESCREEN,
};

export const getBucketFromQuery = (bucket?: string): BUCKETS => {
  if (bucket) {
    return BUCKET_MAPPING[bucket] || BUCKETS.INBOX;
  }

  return BUCKETS.INBOX;
};

export const getQueryFromBucket = (bucket: Bucket): string | undefined => {
  if (bucket === BUCKETS.INBOX) {
    return undefined;
  }

  return Object.keys(BUCKET_MAPPING).find(
    (key: string) => BUCKET_MAPPING[key] === bucket,
  );
};
